import React, { useEffect } from "react";
import { motion } from "framer-motion";
import classes from "./ProjectTemp.module.css";
import { useInView } from "react-intersection-observer";
import { Element } from "react-scroll";

const ProjectTemp = (props) => {
  const { ref, inView } = useInView({
    threshold: 0.8,
  });

  useEffect(() => {
    if (inView) {
      props.onVisible(props.name);
    }
  }, [inView, props.item, props.index, props.onVisible]);

  const techStacks = props.techStacks.map((techStack) => {
    return (
      <li key={techStack.name}>
        <div className={classes.TechstackIcon}>{techStack.icon}</div>
        {techStack.name}
      </li>
    );
  });

  return (
    <Element name={props.name} className={classes.ProjectContainer}>
      <motion.div
        ref={ref}
        data-item-id={props.name}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <div className={classes.ProjectImage}>
          <div className={classes.HoverDiv}>
            <a href={props.link} target="_blank" rel="noreferrer">
              Visit
            </a>
          </div>
          <img src={props.image} alt={props.name} />
        </div>
        <div className={classes.ProjectDetails}>
          <h1>
            {props.name}{" "}
            <span>
              <a href={props.link} target="_blank" rel="noreferrer">
                visit
              </a>
            </span>
          </h1>
          <h4>{props.description}</h4>
          <div className={classes.TechStackDiv}>{techStacks}</div>
        </div>
      </motion.div>
    </Element>
  );
};

export default ProjectTemp;
